import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Form } from 'libs/forms/index';
import { Link } from 'core/routing';
import { staticURL } from 'core/url';
import DocumentHead from 'legacyComponents/documentHead';
import { Div, HeaderMarginTop as Main } from 'legacyComponents/styled/lib';
import { Main as ModalWrapper } from 'apps/modals/styles';
import { LogoStyled } from 'apps/components/header/header.styled';
import { conf as headerConf } from 'apps/components/header/config.yaml';

import { conf as globalConf } from 'apps/config.yaml';

import { NewPasswordFormAppManager } from 'apps/signIn/newPassword/appManager';

import { withNamespaces } from 'react-i18next';

const { siteName } = globalConf;

@withNamespaces()
@observer
export class NewPasswordPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new NewPasswordFormAppManager(null, this.props);
  }

  render() {
    const { app } = this.appManager;
    const { form } = app;
    const { t } = this.props;
    return (
      <Main>
        <Div posiition='relative'>
          <DocumentHead title={`${t('Sign in')} | ${siteName}`} />
          <>
            <Link name='home'>
              <LogoStyled src={staticURL(headerConf.whiteLogo)} solid />
            </Link>
            <ModalWrapper fadedIn>
              <Form
                formStore={form}
                buttonHandler={app.Submit}
                formTitleCentered={true}
                noBorder={true}
              />
            </ModalWrapper>
          </>
        </Div>
      </Main>
    );
  }
}

NewPasswordPage.propTypes = {
  t: PropTypes.func,
};
